import { FC, useMemo } from 'react';
import OG from './og';
import EventJsonLd from './json-ld';
import { useAtomValue } from 'jotai';
import { $ShareInfo } from '~/models/share-info';
import { ACTIVITY_PID, schema } from '../constants';
import { useTranslation } from 'react-i18next';
const FAVICON = 'https://www.lemon8-app.com/favicon.png';

export const ThingsHelmet: FC = () => {
  const { sharePlatform, sharePageName } = useAtomValue($ShareInfo);
  const { t } = useTranslation();

  const schemaHelmet = useMemo(() => {
    let str = schema;

    const commonParams: Record<string, string> = {
      pid: ACTIVITY_PID,
      share_platform: sharePlatform,
      share_position: sharePageName,
    };

    Object.keys(commonParams).forEach((key) => {
      str += `&${key}=${encodeURIComponent(commonParams[key])}`;
    });
    return str;
  }, []);

  return (
    <>
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width,viewport-fit=cover" />
      <link rel="icon" type="image/png" sizes="96x96" href={FAVICON} />
      <link rel="shortcut icon" type="image/png" href={FAVICON} />
      <meta name="referrer" content="origin" />
      <meta name="hostname" content="lemon8-app.com" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="#fff" />
      <title key="title">{t('bucketList_landingPage_header')}</title>

      <meta property="al:ios:url" content={schemaHelmet} />
      <meta property="al:ios:app_store_id" content="1498607143" />
      <meta property="al:ios:app_name" content="Lemon8" />
      <meta property="al:android:url" content={schemaHelmet} />
      <meta property="al:android:app_name" content="Lemon8" />
      <meta property="al:android:package" content="com.bd.nproject" />

      <OG />
      <EventJsonLd />
    </>
  );
};
